import MassiveDownload from '@/app/massive_download/models/MassiveDownload'

class MassiveDownloadConfig {
  constructor ({ id, userId, config, createdAt, name, description }) {
    this.id = id
    this.userId = userId
    this.parameters = new MassiveDownload(config)
    this.createdAt = createdAt
    this.name = name
    this.description = description
  }
}

export default MassiveDownloadConfig



// WEBPACK FOOTER //
// ./src/app/massive_download/models/MassiveDownloadConfig.js